var _defs, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCircleArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.332 40.212l5.652-6.48H17.836v-2.088h23.112L35.332 25.2h2.412l6.66 7.488-6.66 7.524h-2.412z",
    fill: "currentColor"
  })));
}

var MemoSvgCircleArrow = /*#__PURE__*/React.memo(SvgCircleArrow);
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjQgNjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cGF0aCBkPSJNMzUuMzMyIDQwLjIxMkw0MC45ODQgMzMuNzMySDE3LjgzNlYzMS42NDRMNDAuOTQ4IDMxLjY0NEwzNS4zMzIgMjUuMkgzNy43NDRMNDQuNDA0IDMyLjY4OEwzNy43NDQgNDAuMjEySDM1LjMzMloiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";
export { MemoSvgCircleArrow as ReactComponent };